import React, { useState, useCallback } from 'react';
import Logo from './Logo';
import Links from './Links';
import SocialLinks from './SocialLinks';
import './navbar.scss';

var Navbar = function Navbar() {
  var _useState = useState(false),
      mobileMenuOpen = _useState[0],
      setMobileMenuOpen = _useState[1];

  var toggleMenu = useCallback(function () {
    return setMobileMenuOpen(function (prev) {
      return !prev;
    });
  }, [setMobileMenuOpen]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("nav", {
    role: "header",
    "aria-label": "header row",
    className: "navbar is-transparent is-hidden-mobile"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "navbar-brand"
  }, /*#__PURE__*/React.createElement("div", {
    className: "navbar-item"
  }, /*#__PURE__*/React.createElement(Logo, null))), /*#__PURE__*/React.createElement("div", {
    className: "navbar-item"
  }, /*#__PURE__*/React.createElement(SocialLinks, null)))), /*#__PURE__*/React.createElement("nav", {
    role: "navigation",
    "aria-label": "main navigation",
    className: "navbar is-transparent row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "navbar-brand"
  }, /*#__PURE__*/React.createElement("div", {
    className: "navbar-item is-hidden-tablet"
  }, /*#__PURE__*/React.createElement(Logo, null)), /*#__PURE__*/React.createElement("a", {
    role: "button",
    onClick: toggleMenu,
    className: "navbar-burger burger " + (mobileMenuOpen ? 'is-active' : ''),
    "data-target": "navMenu"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }))), /*#__PURE__*/React.createElement("div", {
    id: "navMenu",
    className: "navbar-menu " + (mobileMenuOpen ? 'is-active' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "columns is-gapless is-vcentered is-full-width has-text-centered"
  }, /*#__PURE__*/React.createElement(Links, {
    linkClassName: "navbar-item"
  }), /*#__PURE__*/React.createElement("div", {
    className: "navbar-item is-hidden-tablet"
  }, /*#__PURE__*/React.createElement(SocialLinks, null)))))));
};

export default Navbar;